<template>
  <div
    class="p-6 overflow-y-auto bg-white rounded shadow-2xl"
    style="width: 560px;"
  >
    <div class="mb-3 title">
      <h1 class="mb-1 font-bold">ファイルアップロード</h1>
      <p class="text-sm text-gray-400">
        ファイルフォーマットは「PPTX,PDF」のみに対応しています。
      </p>
      <!-- <div class="p-2 bg-red-100 border border-red-500 border-solid rounded-lg">
        <p class="text-sm text-red-500">
          現在(2024/6/13~)、アップロード可能なファイル形式は「PDF」のみです。<br>
          pptxファイルは、事前にpdfに変換したのちアップしてください。
        </p>
      </div> -->
    </div>
    <div class="content">
      <file-upload-form 
        @before-upload="beforeUpload"
        @after-upload="afterUpload"
      />
    </div>
    <loading
      v-model:active="state.loading"
      color="#818589"
      blur=""
    />
  </div>
  <file-upload-success-modal
    :show-modal="state.showModal"
    @close-modal="state.showModal = false"
  />
</template>

<script>
import { reactive } from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import FileUploadSuccessModal from "./modals/FileUploadSuccessModal.vue";
import FileUploadForm from "./FileUploadeForm.vue"


export default {
  components: {
    FileUploadSuccessModal,
    FileUploadForm,
    Loading,
  },
  setup() {
    const state = reactive({
      showModal: false,
      loading: false,
    });

    const beforeUpload = () => {
      state.loading = true;
    }

    const afterUpload = () => {
      state.loading = false;
      state.showModal = true;
    }

    return {
      state,
      beforeUpload,
      afterUpload
    };
  }
};
</script>